import { EMPTY_ARRAY, TBoardId, TCardId } from '../../../../types/types';
import { BOARDS_RECENT_CARDS_LOCALSTORAGE } from '../constants';

export const getBoardUserRecentCards = (
    boardId: TBoardId,
): TCardId[] => {
    const data = localStorage.getItem(BOARDS_RECENT_CARDS_LOCALSTORAGE);
    const boards = data ? JSON.parse(data) : {};
    return boards[boardId] || EMPTY_ARRAY;
};
